import React from 'react';
import { styled } from '@uhg-abyss/web/tools/styled';
import { V2Card } from '@uhg-abyss/web/ui/Card';
import { V2Button } from '@uhg-abyss/web/ui/Button';
import { useFormV2 } from '@uhg-abyss/web/hooks/useForm';

const SectionStack = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  gap: '24px',
});

const SectionHeader = styled('div', {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: '12px',
  marginBottom: '24px',
});

const Label = styled('p', {
  margin: 0,
  fontWeight: 700,
});

const Value = styled('p', {
  margin: 0,
  wordBreak: 'break-all',
  whiteSpace: 'normal',
});

const DetailGroup = styled('div', {
  display: 'flex',
  flexDirection: 'column',
});

const TwoColumnRow = styled('div', {
  display: 'grid',
  gridTemplateColumns: 'repeat(2, minmax(240px, 340px))',
  gap: '10px',
  justifyContent: 'start',
});

const getUploadedFileName = (fileValue) => {
  if (!fileValue) return 'No file uploaded';
  if (Array.isArray(fileValue)) {
    const file = fileValue[0];
    return file?.name || 'No file name';
  }
  if (typeof fileValue === 'string') return fileValue;
  if (fileValue?.name) return fileValue.name;
  return 'No file name';
};

export const W9InformationCard = ({ onEdit, isPrinting }) => {
  const abyssForm = useFormV2();
  const w9Info = abyssForm.getValues('w9form') || {};

  return (
    <V2Card>
      <SectionHeader>
        <h4>W-9 information</h4>
        {!isPrinting && (
          <V2Button
            variant="outline"
            size="$sm"
            onClick={() => onEdit(1)}
            icon={{
              icon: 'edit',
              position: 'leading',
              variant: 'outlined',
            }}
          >
            Edit
          </V2Button>
        )}
      </SectionHeader>
      <SectionStack>
        <TwoColumnRow>
          <DetailGroup>
            <Label>Name (as shown on income tax return)</Label>
            <Value>{w9Info.name}</Value>
          </DetailGroup>
          <DetailGroup>
            <Label>Federal tax classification</Label>
            <Value>{w9Info.federalTaxClassification}</Value>
          </DetailGroup>
        </TwoColumnRow>

        <TwoColumnRow>
          <DetailGroup>
            <Label>Business name/disregard entity name</Label>
            <Value>{w9Info.businessName}</Value>
          </DetailGroup>
          <DetailGroup>
            <Label>W-9 form</Label>
            <Value>{getUploadedFileName(w9Info.fileName)}</Value>
          </DetailGroup>
        </TwoColumnRow>
      </SectionStack>
    </V2Card>
  );
};